module.exports = __webpack_public_path__ + "static/img/page3.fa1e244.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/page3.jpg
// module id = fYq+
// module chunks = 0